export const markerMapEvents = ['dragstart', 'drag', 'dragend'];
export const markerDOMEvents = ['click', 'mouseenter', 'mouseleave'];
